import util from '../../lib/util';

const template = `
	<div v-show="shown" class="loading">
		<div class="loading-progress" :style="style"></div>
	</div>
`;

export default {
	template,
	props: ['value'],
	data() {
		return {
			shown: false,
			percent: 0,
			opacity: 1,
			counter: 0
		};
	},
	computed: {
		style() {
			return {
				width: this.percent + '%',
				opacity: this.opacity
			};
		}
	},
	methods: {
		async startAnimation() {
			let cnt = ++this.counter;
			this.shown = true;

			await util.sleep(300);
			if (cnt !== this.counter) return;

			this.percent = 15;
			await util.sleep(500);

			while (this.percent < 90 && cnt === this.counter) {
				this.percent += 1;
				await util.sleep(1000);
			}
		},
		async finishAnimation() {
			this.percent = 100;
			this.opacity = 0.5;
			await util.sleep(500);
			if (!this.value) {
				this.shown = false;
				this.percent = 0;
				this.opacity = 1;
			}
		}
	},
	watch: {
		value() {
			if (this.value) {
				this.startAnimation();
			} else {
				this.finishAnimation();
			}
		}
	}
};